"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Empty = Empty;
exports.EmptyIcon = EmptyIcon;
var _core = require("@blueprintjs/core");
var React = _interopRequireWildcard(require("react"));
var _cardLevel = require("../../common/cardLevel");
var _colors = require("../../common/colors");
var _Card = require("../card/Card");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _typography = require("../typography/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var cardPropsDefault = {
  level: _cardLevel.CardLevel.FILLED
};
function EmptyIcon(_ref) {
  var strokeOverride = _ref.stroke;
  var stroke = strokeOverride || _colors.Colors.IVORY_20;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '122px',
      height: '122px',
      border: "1px solid ".concat(stroke)
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement(_Icon.Icon60, {
    icon: _iconNames.IconNames60.CROSS,
    stroke: stroke
  }), /*#__PURE__*/React.createElement(_Icon.Icon60, {
    icon: _iconNames.IconNames60.RAINBOW,
    stroke: stroke
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement(_Icon.Icon60, {
    icon: _iconNames.IconNames60.TARGET,
    stroke: stroke
  }), /*#__PURE__*/React.createElement(_Icon.Icon60, {
    icon: _iconNames.IconNames60.FLOWER,
    stroke: stroke
  })));
}
function Empty(_ref2) {
  var _ref2$cardProps = _ref2.cardProps,
    cardProps = _ref2$cardProps === void 0 ? cardPropsDefault : _ref2$cardProps,
    children = _ref2.children,
    _ref2$icon = _ref2.icon,
    icon = _ref2$icon === void 0 ? /*#__PURE__*/React.createElement(EmptyIcon, null) : _ref2$icon,
    description = _ref2.description,
    title = _ref2.title;
  var formattedTitle = typeof title === 'string' ? /*#__PURE__*/React.createElement(_typography.Lead, null, title) : title;
  var formattedDescription = typeof description === 'string' ? /*#__PURE__*/React.createElement(_typography.Body, {
    muted: true
  }, description) : description;
  return /*#__PURE__*/React.createElement(_Card.Card, cardProps, /*#__PURE__*/React.createElement(_core.NonIdealState, {
    title: formattedTitle,
    icon: icon,
    description: formattedDescription,
    action: /*#__PURE__*/React.createElement(React.Fragment, null, children)
  }));
}